module.exports = __webpack_public_path__ + "img/hezuo.ce367fa9.jpg";